import React from 'react';
import '../inline-background.css';
import aiAssistantBackground from '../AIAssistant.webp';

interface BackgroundContainerProps {
  children: React.ReactNode;
}

const BackgroundContainer: React.FC<BackgroundContainerProps> = ({ children }) => {
  return (
    <>
      <div
        className="app-background"
        style={{ backgroundImage: `url(${aiAssistantBackground})` }}
      ></div>
      <div className="background-overlay"></div>
      {children}
    </>
  );
};

export default BackgroundContainer;
